import React from 'react';
import { Layout, Space, Button } from 'antd';
import { LogoutOutlined, LoginOutlined } from '@ant-design/icons';
import { useFlowStore } from '../store';
import { useLocation, Link } from 'react-router-dom';
import flowLearningLogo from '../assets/flow-learning.jpg';

const { Header } = Layout;

interface AuthenticatedLayoutProps {
  children: React.ReactNode;
}

const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({ children }) => {
  const { userDetails, logout } = useFlowStore();
  const location = useLocation();
  const isFlowPage = location.pathname.includes('/map');

  const currentUser = userDetails;

  const handleLogout = () => {
    logout();
  };

  return (
    <Layout>
      <Header className="app-header">
        <Link to="/topics" className="app-header-logo">
          <img src={flowLearningLogo} alt="Flow Learning" />
        </Link>

        <Space>
          {currentUser?.username ? (
            <>
              <Link to={`/user-page/${currentUser?.id}`}>
                <span>{currentUser?.username || 'User'}</span>
              </Link>
              <Button
                icon={<LogoutOutlined />}
                onClick={handleLogout}
                type="primary"
                danger
              >
                Logout
              </Button>
            </>
          ) : (
            <Link to={`/`}>
              <Button icon={<LoginOutlined />} type="primary">
                Login
              </Button>
            </Link>
          )}
        </Space>
      </Header>

      <div className={`app-content ${isFlowPage ? 'flow-page' : ''}`}>
        {children}
      </div>
    </Layout>
  );
};

export default AuthenticatedLayout;
